





























































































































































































































































































import { Component, Watch } from 'vue-property-decorator';
import { InvoiceDetailsModule } from '@/store/modules/invoiceDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import IconConstants from '@/lib/iconConstants';
import InvoiceLineDto from '@/models/Invoices/InvoiceLineDto';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import TimesheetStatus from '@/components/Timesheets/Display/TimesheetStatus.vue';
import JobWorkerOfferStatus from '@/components/JobWorkerOffers/Display/JobWorkerOfferStatus.vue';

@Component({
  name: 'InvoiceLines',
  components: {
    TimesheetStatus,
    JobWorkerOfferStatus,
  },

})
export default class extends GiganautVue {

  private timesheetHeaders = [
    { text: "Worker", value: 'worker.person.firstName'},
    { text: "Date & Time", value: 'startAt'},
    { text: "Shift Units", value: 'shiftUnitsNet'},
    { text: "Travel Time", value: 'shiftTimeUnitsForCharge'},
    { text: "Travel Distance Units", value: 'totalDistanceForCharge'},
    { text: "Status", value: 'status'},
  ];

    private placementHeaders = [
    { text: "Worker", value: 'worker.person.firstName'},
    { text: "Annual Salary", value: 'annualSalary'},
    { text: "Start Date", value: 'startDate'},
    { text: "Placement Fee", value: 'shiftUnitsNet'},
    { text: "Status", value: 'status'},
  ];

  get currentInvoice() {
    return InvoiceDetailsModule.currentInvoice;
  }

  get invoiceLines() {
    return InvoiceDetailsModule.invoiceLines;
  }

  get loadingInvoiceLines() {
    return InvoiceDetailsModule.loadingInvoiceLines;
  }

  get loadingDialog() {
    return InvoiceDetailsModule.loadingDialog;
  }

  async mounted() {
    console.log("InvoiceLines mounted");
    // Try to load invoice lines, but the store will handle checking if currentInvoice is available
    await this.loadInvoiceLines();
  }

  // Watch for currentInvoice to become available and load invoice lines
  @Watch('currentInvoice')
  async onCurrentInvoiceChanged(newInvoice: any, oldInvoice: any) {
    // Only load if we now have an invoice and we didn't before (or it changed)
    if (newInvoice && newInvoice.id && (!oldInvoice || newInvoice.id !== oldInvoice.id)) {
      await this.loadInvoiceLines();
    }
  }

  async refreshInvoiceLines() {
    await this.loadInvoiceLines();
  }

  async generateInvoiceLines() {
    // The store action will handle checking if currentInvoice is available
    await InvoiceDetailsModule.generateInvoiceLines();
  }

  async deleteInvoiceLines() {
    const options: VuetifyConfirmObject = {
      buttonTrueText: "DELETE ALL",
      buttonFalseText: "CANCEL",
      buttonTrueColor: "error",
      buttonFalseColor: "primary",
    }
    const result = await this.$confirm('Are you sure you want to delete all invoice lines? This action cannot be undone.', options);
    if (result) {
      await InvoiceDetailsModule.deleteInvoiceLines();
    }
  }

  async sendToXero() {
    if (!this.currentInvoice || !this.currentInvoice.id) {
      console.warn("Cannot send to Xero: currentInvoice not available");
      return;
    }

    const options: VuetifyConfirmObject = {
      buttonTrueText: "SEND TO XERO",
      buttonFalseText: "CANCEL",
      buttonTrueColor: "primary",
      buttonFalseColor: "primary",
    }
    const result = await this.$confirm('This will send the invoice to Xero and can only be done once. Are you sure you want to proceed?', options);
    if (result) {
      await InvoiceDetailsModule.createXeroInvoice(this.currentInvoice.id);
    }
  }

  async loadInvoiceLines() {
    // The store action will handle checking if currentInvoice is available
    await InvoiceDetailsModule.getInvoiceLines();
  }

  calculateLineTotal(line: InvoiceLineDto): number {
    const hoursTotal = line.shiftUnits * line.hoursChargeRate;
    const travelTotal = line.travelUnits * line.hoursChargeRate;
    const distanceTotal = line.distanceUnits * line.distanceChargeRate;
    const placementTotal = line.jobPlacementFee;
    return hoursTotal + travelTotal + distanceTotal + placementTotal;
  }

  calculateTotalAmount(): number {
    return this.invoiceLines.reduce((total, line) => {
      return total + this.calculateLineTotal(line);
    }, 0);
  }

  getPositionName(line: InvoiceLineDto): string {
    return (line.bookingRole && line.bookingRole.position && line.bookingRole.position.name) || 'N/A';
  }

  getLocationName(line: InvoiceLineDto): string {
    // Get location name from the first timesheet if available
    if (line.timesheets && line.timesheets.length > 0 && line.timesheets[0].location) {
      return line.timesheets[0].location.brandName || line.timesheets[0].location.registeredName || 'N/A';
    }
    return 'N/A';
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  formatTime(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }

  formatNumber(value: number, decimalPlaces = 2): string {
    return (value || 0).toFixed(decimalPlaces);
  }

  getAccountForLineType(desk: DeskDto, lineType: 'shift' | 'travel' | 'distance' | 'placement'): string {

    switch (lineType) {
      case 'shift':
        return desk.externalAccountingSystemShiftHoursAccount || '-';
      case 'travel':
        return desk.externalAccountingSystemTravelHoursAccount || '-';
      case 'distance':
        return desk.externalAccountingSystemDistanceAccount || '-';
      case 'placement':
        return desk.externalAccountingSystemPlacementAccount || '-';
      default:
        return '-';
    }
  }

  getCategory1ForLineType(desk: DeskDto, lineType: 'shift' | 'travel' | 'distance' | 'placement'): string {
    switch (lineType) {
      case 'shift':
        return desk.externalAccountingSystemShiftHoursCategory1 || '-';
      case 'travel':
        return desk.externalAccountingSystemTravelHoursCategory1 || '-';
      case 'distance':
        return desk.externalAccountingSystemDistanceCategory1 || '-';
      case 'placement':
        return desk.externalAccountingSystemPlacementCategory1 || '-';
      default:
        return '-';
    }
  }


  getCategory2ForLineType(desk: DeskDto, lineType: 'shift' | 'travel' | 'distance' | 'placement'): string {
    switch (lineType) {
      case 'shift':
        return desk.externalAccountingSystemShiftHoursCategory2 || '-';
      case 'travel':
        return desk.externalAccountingSystemTravelHoursCategory2 || '-';
      case 'distance':
        return desk.externalAccountingSystemDistanceCategory2 || '-';
      case 'placement':
        return desk.externalAccountingSystemPlacementCategory2 || '-';
      default:
        return '-';
    }
  }
}
